// Translations
import landing from '../views/landing/translations/ru'

// Translation: Password change (Russian)
export default Object.freeze({
	name: '',
	views: { landing }
})
